module.exports = "var React = require('react');\r\nvar {Router, Route, IndexRoute, hashHistory } = require('react-router');\r\n\r\n// This is the path to our previous defined App component\r\nvar App = require('./App');\r\n\r\n// Some app's screen components\r\nvar Home = require('./Home')\r\nvar Hello = require('./Hello')\r\n\r\nvar Router = ReactRouter\r\nmodule.exports = (\r\n  <Router history={ hashHistory } >\r\n    <Route path=\"/\" component={ App }>\r\n      <IndexRoute component={ Home } />\r\n      <Route path=\"/sidebar\" component={ Sidebar } />\r\n    </Route>\r\n  </Router>\r\n);\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/routes.html
 ** module id = 267
 ** module chunks = 0
 **/